// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-IKKA","copyright":"styles_copyright__7CSyX","btns":"styles_btns__26A+P","btn_unstyle":"styles_btn_unstyle__OIjKW"};